import { enableProdMode, ErrorHandler, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { RnimuQuizModule } from '@rsmu/quiz';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { APP_ROUTES } from './app/app.routes';
import { provideRouter } from '@angular/router';
import { AppErrorHandler } from './app/core/handlers/error.handler';
import { IszConfigInterface, IszModule } from '@rsmu/isz';
import { Configuration, ConfigurationParameters, ApiModule as OepApiModule } from '@rsmu/oep-api';
import { IdpSecurityInterceptor, BasicSecurityInterceptor, AuthModule, AuthConfig } from '@rsmu/auth';
import { RetryInterceptor } from './app/core/interceptors/retry.interceptor';
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTreeModule } from '@angular/material/tree';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { MatProgressBarModule} from '@angular/material/progress-bar';

if (environment.production) {
  enableProdMode();
}

export function authConfigFactory (): AuthConfig | null {
  return {
    cubaClientId: environment.clientId,
    cubaSecret: environment.secret,
    idpUrl: environment.idpUrl,
    isMobileApp: false,
    loginUrl: environment.loginUrl,
    storageKey: environment.authStorageKey ?? 'rsmuTokenData'
  }
}

export function oepApiConfigFactory(): Configuration {
  const params: ConfigurationParameters = {
    basePath: environment.apiUrl
  };
  return new Configuration(params);
}

export function iszConfigFactory(): IszConfigInterface {
  return {
    url: environment.iszUrl
  }
}

export const MATERIAL_MODULES = [
  MatButtonModule,
  MatDialogModule,
  MatExpansionModule,
  MatIconModule,
  MatSidenavModule,
  MatTableModule,
  MatToolbarModule,
  MatProgressSpinnerModule,
  MatProgressBarModule,
  MatSnackBarModule,
  MatRippleModule,
  MatTreeModule,
  MatBottomSheetModule,
  MatListModule,
  PdfViewerModule,
  CdkStepperModule
]


bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      AuthModule.forRoot(authConfigFactory),
      OepApiModule.forRoot(oepApiConfigFactory),
      IszModule.forRoot(iszConfigFactory),
      StoreModule.forRoot({}),
      EffectsModule.forRoot([]),
      BrowserModule,
      environment.rnimuQuizConfig && RnimuQuizModule.forRoot(environment.rnimuQuizConfig) || [],
      ...MATERIAL_MODULES
    ),
    { provide: HTTP_INTERCEPTORS, useClass: RetryInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: environment.production ? IdpSecurityInterceptor : BasicSecurityInterceptor, multi: true },
    { provide: ErrorHandler, useClass: AppErrorHandler },
    provideRouter(APP_ROUTES),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi())
  ]
}).catch(err => console.error(err));